/**
 * ページ毎検索結果数を算出する
 * @param {string | string[] | undefined} querySo - 検索結果数クエリ
 * @param {number} defaultJobCountPerPage - デフォルトの検索結果数
 * @returns ページ毎検索結果数
 */
export const calcJobCountPerPage = (
  querySo: string | string[] | undefined,
  defaultJobCountPerPage: number
) =>
  querySo !== undefined && [10, 20, 50].includes(Number(querySo))
    ? Number(querySo)
    : defaultJobCountPerPage;
